import React, { useEffect, useState, useRef } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const Counter = ({
  end,
  duration = 2000,
  prefix = "",
  suffix = "",
  decimals = 0
}: {
  end: number;
  duration?: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
}) => {
  const [count, setCount] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [hasAnimated, setHasAnimated] = useState(false);
  useEffect(() => {
    if (isVisible && !hasAnimated) {
      let startTime: number | null = null;
      const startValue = 0;
      const step = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const easeOutExpo = (x: number): number => {
          return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
        };
        const currentCount = startValue + (end - startValue) * easeOutExpo(progress);
        setCount(currentCount);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          setHasAnimated(true);
        }
      };
      window.requestAnimationFrame(step);
    }
  }, [isVisible, hasAnimated, end, duration]);
  return <span ref={ref} className="tabular-nums">
      {prefix}
      {count.toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    })}
      {suffix}
    </span>;
};
export default function ThePowerOfConnection() {
  const stats = [{
    id: 1,
    value: 3000,
    label: "Leaders",
    prefix: "",
    suffix: "+",
    decimals: 0
  }, {
    id: 2,
    value: 100,
    label: "Chefs",
    prefix: "",
    suffix: "+",
    decimals: 0
  }, {
    id: 3,
    value: 2,
    label: "Impact",
    prefix: "$",
    suffix: "M+",
    decimals: 0
  }];
  return <section id="the-power-of-connection" className="dark bg-background text-foreground relative overflow-hidden py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden select-none">
        <span className="text-foreground/5 font-serif text-[40rem] font-bold leading-none opacity-10 blur-sm" aria-hidden="true">
          S
        </span>
      </div>

      <div className="container relative mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8">
          {stats.map((stat, i) => <div key={stat.id} data-index={i} className="flex flex-col items-center justify-center text-center">
              <div className="mb-2 text-6xl font-bold tracking-tight sm:text-7xl md:text-8xl font-serif text-chart-2 drop-shadow-[0_0_15px_rgba(var(--color-chart-2),0.4)]">
                <Counter end={stat.value} prefix={stat.prefix} suffix={stat.suffix} decimals={stat.decimals} />
              </div>
              <p className="text-muted-foreground text-lg font-medium uppercase tracking-widest font-sans">
                {stat.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}